export default {"src":"/_next/static/media/Chainlink.851ca49d.svg","height":31,"width":94,"blurWidth":0,"blurHeight":0};